export function getChatWidgetPanelClassName(isOpen: boolean) {
  const baseClassName =
    'fixed inset-0 z-50 flex w-screen flex-col overflow-hidden border-border-subtle bg-background shadow-layer transition-all duration-300 lg:inset-auto lg:bottom-4 lg:right-4 lg:w-96 lg:rounded-2xl lg:border';

  return isOpen
    ? `${baseClassName} h-[100dvh] opacity-100 translate-y-0 lg:h-[min(40rem,calc(100vh-2rem))]`
    : `${baseClassName} h-0 opacity-0 translate-y-4 pointer-events-none`;
}
